import { Switch } from '@/common/ui/switch'
import showErrorToast from '@/common/utils/showErrorToast'
import { useState } from 'react'
import { toast } from 'sonner'

interface SetIsActiveProps {
	defaultChecked: boolean
	onMutate: (value: boolean) => Promise<void>
	successMessage?: string
	errorMessage?: string
	disabled?: boolean
}

export default function SetIsActive({
	defaultChecked,
	onMutate,
	successMessage = 'อัพเดทสถานะสำเร็จ',
	disabled = false,
}: SetIsActiveProps) {
	const [isLoading, setIsLoading] = useState(false)

	const handleChange = async (value: boolean) => {
		setIsLoading(true)
		try {
			await onMutate(value)
			toast.success(successMessage)
		} catch (error) {
			showErrorToast(error as Error)
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<Switch
			checked={defaultChecked}
			onCheckedChange={handleChange}
			disabled={isLoading || disabled}
		/>
	)
}
